// extracted by mini-css-extract-plugin
module.exports = {"stats":"MonitoringSummary_stats__GpmXq","title":"MonitoringSummary_title__2i_v9","label":"MonitoringSummary_label__2givx","value":"MonitoringSummary_value__vb47u"};